import {SectionHeader} from "./SectionHeader";
import {GOOGLE_MAPS_EMBED_URL} from "../../config"

const HOURS = [
    {day: "Montag", time: "08:00 – 12:00  |  15:00 – 18:00"},
    {day: "Dienstag", time: "08:00 – 16:00"},
    {day: "Mittwoch", time: "08:00 – 12:00"},
    {day: "Donnerstag", time: "08:00 – 12:00  |  15:00 – 18:00"},
    {day: "Freitag", time: "08:00 – 12:00"},
    {day: "Samstag", time: "Geschlossen", closed: true},
    {day: "Sonntag", time: "Geschlossen", closed: true},
];

const CONTACT_ITEMS = [
    {icon: "📞", label: "Telefon", value: "06142 – 17 15 44"},
    {icon: "📍", label: "Adresse", value: "Wilhelm-Sturmfels-Straße 18, 65428 Rüsselsheim am Main"},
    {icon: "🚌", label: "ÖPNV", value: "Bushaltestelle Hochheimerstraße (Linie 6, 7b)"},
];

function getTodayIndex() {
    const day = new Date().getDay();
    return [6, 0, 1, 2, 3, 4, 5][day];
}

export function MapAndContact() {
    const todayIdx = getTodayIndex();

    return (
        <section id="kontakt">
            <div className="map-contact-grid">
                <div className="map-wrapper">
                    <iframe
                        src={GOOGLE_MAPS_EMBED_URL}
                        title="Praxis Standort"
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
                <div className="contact-panel">
                    <SectionHeader title="Öffnungszeiten & Kontakt" isKontak={true} sub="Wir freuen uns auf Ihren Besuch. Ein Treppenlift ist verhanden"/>
                    <table className="hours-table" style={{marginBottom: "1.8rem"}}>
                        <tbody>
                        {HOURS.map(({day, time, closed}, idx) => (
                            <tr key={day} className={closed ? "closed" : idx === todayIdx ? "today-row" : ""}>
                                <td>
                                    {day}
                                    {idx === todayIdx && <span className="today-badge">heute</span>}
                                </td>
                                <td>{time}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div className="contact-info">
                        {CONTACT_ITEMS.map(({icon, label, value}) => (
                            <div className="contact-row" key={label}>
                                <div className="contact-icon">{icon}</div>
                                <div className="contact-detail">
                                    <strong>{label}</strong>
                                    <span>{value}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}